import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class CreateCustomChargeCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(user_id, lines): Promise<{ [key: string]: object; }> {
    let args = {
      user_id:user_id,
      lines:lines,
    };
    try {
      return this.dispatcher.dispatch('create.custom.charge', args);
    } catch(error) {
      console.error('Error al crear el cargo', error)
    }
  }
}